import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { XLarge } from '@outdoor-voices/ui';
import cc from 'classcat';
import Button from '@outdoor-voices/ui/dist/components/Button';
import PropTypes from 'prop-types';
import css from './PhotoModal.module.scss';
import PhotoView from './PhotoView';
import PhotosView from './PhotosView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PhotoModal = function PhotoModal(_ref) {
  var id = _ref.id,
      on = _ref.on,
      onHide = _ref.onHide,
      onSetReview = _ref.onSetReview,
      onShowPhotos = _ref.onShowPhotos,
      orderBy = _ref.orderBy,
      productShopifyId = _ref.productShopifyId,
      showPhotos = _ref.showPhotos,
      title = _ref.title;

  var closeButton = /*#__PURE__*/_jsx("div", {
    className: css.button,
    children: /*#__PURE__*/_jsx(Button, {
      ariaLabel: "Click to close dialog",
      onClick: onHide,
      icon: true,
      tabIndex: on ? 0 : -1,
      children: /*#__PURE__*/_jsx(XLarge, {})
    })
  });

  return /*#__PURE__*/_jsxs("div", {
    "aria-hidden": on ? 'false' : 'true',
    className: cc([css.root, _defineProperty({}, css.on, on)]),
    children: [!showPhotos && /*#__PURE__*/_jsx(PhotoView, {
      closeButton: closeButton,
      id: id,
      on: on,
      onShowPhotos: onShowPhotos,
      onSetReview: onSetReview,
      orderBy: orderBy,
      title: title
    }), showPhotos && /*#__PURE__*/_jsx(PhotosView, {
      closeButton: closeButton,
      on: on,
      onSetReview: onSetReview,
      orderBy: orderBy,
      productShopifyId: productShopifyId,
      title: title
    })]
  });
};

PhotoModal.defaultProps = {
  review: false
};
PhotoModal.propTypes = {
  id: PropTypes.string,
  on: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSetReview: PropTypes.func.isRequired,
  onShowPhotos: PropTypes.func.isRequired,
  orderBy: PropTypes.string,
  showPhotos: PropTypes.bool.isRequired,
  productShopifyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  title: PropTypes.string.isRequired
};
export default PhotoModal;